/* eslint-disable */

import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import ApplicationsTitlesListPerDay from "./ApplicationsTitlesListPerDay";
import ApplicationsTitlesList from "./ApplicationsTitlesList";
import ApplicationsTitlesListOld from './ApplicationsTitlesListOld';
import ScrappedJobsCount from './ScrappedJobsCount.js';


function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  
  export default function BasicTabs() {
    const [value, setValue] = React.useState(1);
  
    const handleChange = (event, newValue) => {
      setValue(newValue);
    };
  
    return (
      <Box sx={{ width: '100%',marginTop:"-60px" }} >
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
            <Tab label="Total Resumes" {...a11yProps(0)} />
            <Tab label="Resumes Per Day" {...a11yProps(1)} />
            <Tab label="Old Resumes" {...a11yProps(2)} />
            {/* <Tab label="Scrapped Jobs" {...a11yProps(3)} /> */}
           
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
        <ApplicationsTitlesList/>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <ApplicationsTitlesListPerDay/>
        </TabPanel>
        <TabPanel value={value} index={2}>
          <ApplicationsTitlesListOld/>
        </TabPanel>
        {/* <TabPanel value={value} index={3}>
          <ScrappedJobsCount/>
        </TabPanel> */}
    
      </Box>
    );
  }